import React from 'react';

import {
  Form,
  FormError,
  Label,
  LabelInput,
  Select,
} from '../../common/components/form';
import Button from '../../../ui/button/Button';

import { Localize } from '../../../locale/localization';

const CreateTeamForm = (props) => {
  const {
    enabled,
    onCancel,
    onSubmit,
    onBlur,
    onInputChange,
    formError,
    errors,
    touchedFields,
    isValid,
    name,
    email,
    channel,
    channels,
    region,
    regions,
  } = props;

  const channelOptions = channels.map((op) => <option key={op._id} value={op._id}>{op.name}</option>);
  const regionOptions = channel ? regions.filter(region => region.channel === channel).map((region) => <option key={region._id} value={region._id}>{region.name}</option>) : [];

  return (
    <Form
      onSubmit={onSubmit}
      autoCorrect="off"
      autoComplete="off"
      noValidate
      spellCheck="false"
      onBlur={onBlur}
    >
      {channels.length > 0 && (
        <Label
          half={regions.length > 0}
          label="Jälleenmyyjä">
          <Select
            value={channel}
            name="channel"
            error={errors['channel'] && touchedFields.indexOf('channel') > -1}
            errorMessage={errors['channel']}
            onChange={onInputChange}
          >
            <option value="" disabled>{Localize('channel')}</option>
            {channelOptions}
          </Select>
        </Label>
      )}
      {regions.length > 0 && (
        <Label
          half={channels.length === 1}
          label="Alue">
          <Select
            disabled={regionOptions.length === 0}
            value={region}
            name="region"
            error={errors['region'] && touchedFields.indexOf('region') > -1}
            errorMessage={errors['region']}
            onChange={onInputChange}
          >
            <option value="">{Localize('region.none')}</option>
            {regionOptions}
          </Select>
        </Label>
      )}
      <LabelInput
        half
        label="Tiimin nimi"
        name="name"
        type="text"
        value={name}
        error={errors['name'] && touchedFields.indexOf('name') > -1}
        errorMessage={errors['name']}
        onChange={onInputChange}
      />
      <LabelInput
        half
        label="Tiimiesimiehen sähköpostiosoite"
        name="email"
        type="email"
        value={email}
        error={errors['email'] && touchedFields.indexOf('email') > -1}
        errorMessage={errors['email']}
        onChange={onInputChange}
      />
      {formError && (
        <FormError>{formError}</FormError>
      )}
      <footer>
        <Button onClick={onCancel} theme="light">{Localize('action.cancel')}</Button>
        <Button
          disabled={!isValid || !enabled}
          type="submit"
          icon="#chevron-right"
          iconRight={true}
        >
          {Localize('action.submit')}
        </Button>
      </footer>
    </Form>
  );
};

export default CreateTeamForm;


// WEBPACK FOOTER //
// ./src/modules/team/components/CreateTeamForm.js